import { db } from "../firebase";
import {
    collection,
    doc,
    getDoc,
    getDocs,
    limit,
    query,
    serverTimestamp, setDoc,
    updateDoc,
    where,

} from 'firebase/firestore'
import { converttime } from "../components/converttime";
import { dealstages } from "../components/CONSTANTS";
import { company } from "faker";


const leadsCollectionRef = collection(db, "Formsdata");
const leadsArchiveCollectionRef = collection(db, "Archive");
const companyQuestionsRef = collection(db, "ServiceCompany");


export const getLeadsAPI = async (company, len) => {

    const q = await query(leadsCollectionRef, where("company", "==", company), limit(len));


    return (await getDocs(q)).docs.map((doc) => ({ ...doc.data(), id: doc.id }));

}


export const getAllCompanyLeads = async (company) => {

    const q = await query(leadsCollectionRef, where('company', "==", company));
    return (await getDocs(q)).docs.map((doc) => ({ ...doc.data(), id: doc.id }));
}

export const getCompanyQuestions = async (company, len) => {
    const a = await query(companyQuestionsRef, where("company", "==", "companyQuestion", company), limit(len));
    return (await getDocs(a)).docs.map((doc) => ({ ...doc.data(), id: doc.id }));

}

export const getArchiveLeadsApi = async (company, len) => {


    const q = query(leadsArchiveCollectionRef, where("company", "==", company), limit(len))
    return (await getDocs(q)).docs.map((doc) => ({ ...doc.data(), id: doc.id }));

}


const companyLeads = async (company) => {

    const q = await query(collection(db, "Formsdata"), where("company", "==", company));
    return await getDocs(q);
}


export const getDataFromUserStats = async (company) => {

    const q = await query(collection(db, "UserStats"), where("company", "==", company));


    return (await getDocs(q)).docs.map((doc) => ({ ...doc.data(), id: doc.id }));
}

export const getLeadsValue = async (company) => {


    let value = 0;


    const querysnapshot = await companyLeads(company);

    if (!companyLeads(company).empty) {
        querysnapshot.forEach((doc) => {
            if (doc.data().value !== undefined || doc.data().value === typeof "string") {

                value += doc.data().value;

            }
        })
        return value;


    }
}


export const getLeadAPI = async (match) => {

    let object = {}

    const docRef = doc(db, 'Formsdata', match);
    await getDoc(docRef).then(
        function (snapshot) {
            object = snapshot.data()
        }
    )
    return object
}


export const updateLeadValue = async (id, value) => {

    /*
    const docRef = await doc(db, "Formsdata", id);
    await setDoc(docRef, {
        value: value
    }, {merge: true})


     */
}
export const updateLeadDealstage = async (id, dealstage) => {
    const docRef = await doc(db, "Formsdata", id);

    await setDoc(docRef, {
        dealstage: dealstage
    }, { merge: true })
}

export const updatePDFFileName = async (id, filename) => {
    const docRef = await doc(leadsCollectionRef, id);
    await setDoc(docRef, {
        pdfFileName: filename
    }, { merge: true })
}

export const updateLead = async (
    id,
    docSnapDistric,
    docSnapEmail,
    docSnapFirstName,
    docSnapLastName,
    docSnapPhoneNumber,
    docSnapZipCode,
    docSnapNote,
    price
) => {
    const docRef = doc(db, 'Formsdata', id);


    if (docSnapNote != null) {
        await updateDoc(docRef, {
            note: docSnapNote
        })
    }
    if (docSnapDistric != null) {
        await updateDoc(docRef, {
            district: docSnapDistric,
        })
    }
    if (docSnapEmail != null) {
        await updateDoc(docRef, {
            email: docSnapEmail,
        })
    }
    if (docSnapFirstName != null) {
        await updateDoc(docRef, {
            firstname: docSnapFirstName,
        })
    }
    if (docSnapLastName != null) {
        await updateDoc(docRef, {
            lastname: docSnapLastName,
        })
    }
    if (docSnapPhoneNumber != null) {
        await updateDoc(docRef, {
            phonenumber: docSnapPhoneNumber,
        })
    }
    if (docSnapZipCode != null) {
        await updateDoc(docRef, {
            zipcode: docSnapZipCode,
        })
    }


    if (price !== null) {
        await setDoc(docRef, {
            value: price
        }, { merge: true })
    }


}

export const getValuesOfLeadPerUser = async (company) => {
    const q = await query(collection(db, "User"), where("Company", "==", company));
    const data = await getDocs(q);

    let arr = [{}]

    data.forEach((doc) => {
        arr.push(doc.data())
    })

    return arr;
}


export const updatePandaDocStatusInFirestore = async (id, status) => {
    const docRef = doc(db, "Formsdata", id);
    if (status !== null) {
        await setDoc(docRef, {
            status: status
        }, { merge: true })
    }
}


export const setDocDeleted = async (id) => {
    const docRef = doc(db, "Formsdata", id);


    await setDoc(docRef, {
        deleted: true
    }, { merge: true })
}

export const denyLeadAPI = async (id) => {

    const leadRef = doc(db, "Formsdata", id);
    await setDoc(leadRef, {
        approved: false,
        statusUpdated: serverTimestamp()
    }, { merge: true })
}
export const acceptLeadAPI = async (id) => {

    const leadRef = doc(db, "Formsdata", id);
    await setDoc(leadRef, {
        approved: true,
        statusUpdated: serverTimestamp()
    }, { merge: true })
}


export const updateLeadPandaDocValue = async (docID, pandaID) => {
    const leadReference = doc(db, "Formsdata", docID);


    let data = await getLeadAPI(docID);
    if (data.pandadocID) {
        return false;
    } else {

        await updateDoc(leadReference, {
            pandadocID: pandaID,
            dealstage: dealstages.OFFERTSKICKAD,

        })

    }


}

export const updateLeadPandaStatus = async (docID, status, date_modified, date_completed, name, completed) => {
    const leadRef = doc(db, "Formsdata", docID);

    const newDatemodified = converttime(date_modified);
    const newcompleteddate = converttime(date_completed);
    try {
        await setDoc(leadRef, {
            status: status,
            pandadocdatemodified: newDatemodified,
            pandadocdatecompleted: newcompleteddate,
            pandadocdocname: name,
            completed: completed
        }, { merge: true })
    } catch (e) {
        return "Ett fel uppstod med status"
    }
}


export const updateLeadPandaSessionValue = async (docID, sessionID, pandadocstatus) => {
    const leadReference = doc(db, "Formsdata", docID);
    if (leadReference) {
        await updateDoc(leadReference, {
            sessionID: sessionID,
        }).catch(console.error)
    }
}

export const getLeadSessionID = async (docID) => {
    const leadref = doc(db, "Formsdata", docID);

    const sess = await (await getDoc(leadref)).get('sessionID');

    return sess;
}

